// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"53":"91d52a65","157":"e14d1a3c","743":"91d52a65","866":"91d52a65"}[chunkId] + ".css";
};